import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';

@Component({
  selector: 'app-create-privilege',
  templateUrl: './create-privilege.component.html',
  styleUrl: './create-privilege.component.css',
  standalone: false
})
export class CreatePrivilegeComponent implements OnInit{
  privilegeManagementForm: FormGroup;
  isDarkMode!: boolean;

  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CreatePrivilegeComponent>,
    @Inject(MAT_DIALOG_DATA) public editModeData: any,
    private apiService: ApiService,
  ) {}



  initForm(): void {
    this.privilegeManagementForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(40)]],
      description: ['', [Validators.required, Validators.maxLength(65)]],
    });
  }

  ngOnInit(): void {

    this.initForm();

  }

  closeModal(): void {
    this.dialogRef.close();
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload()
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }


  openConfirmModal() {

        let dialogRef = this.dialog.open(ConfirmActionComponent, {
          width: '400px',
          backdropClass: 'modal-form-backdrop',
          hasBackdrop: true,
          panelClass: ['modal-form', 'modal-no-overflow-changed'],
          disableClose: true,
          data: {
            title: "Confirm privilege creation?",
            body: '',
            confirmText: 'Yes',
            lottieIconPath: 'assets/lottie/alert.json',
            onConfirm: () => {

              this.savePrivilege()

            },
            onCancel: () => {
              // dialogRef.close()
            },
            showCancelButton: true,
            showConfirmButton: true,
          },
        });

  }



  savePrivilege(): void {

    const formData = this.privilegeManagementForm.value;

        this.isSubmitting = true;

        const request = {
          permission: formData.name,
          description: formData.description,
        };

          this.apiService
            .post('/privileges/create', request)
            .pipe(
              finalize(() => {
                this.isSubmitting = false;
              })
            )
            .subscribe(
              (response: any) => {

                this.openSuccessModal('Privilege saved successfuly');

                this.dialogRef.close();
              },
              (error) => {
                this.openErrorModal(error?.message)
              }
            );

    this.isSubmitAttempted = true;
  }



}
